import { TrackedOrderSchema, type OrderLookupInput, type TrackedOrder } from '@xshop/shared';
import { fetchApi } from './client';

// Asks the shop for a shopper's own order by its number and phone, checking the answer's shape at the edge.
export async function lookupOrder(input: OrderLookupInput): Promise<TrackedOrder> {
  const data = await fetchApi<unknown>('/order-lookup', { method: 'POST', body: JSON.stringify(input) });
  return TrackedOrderSchema.parse(data);
}
